module.exports = __webpack_public_path__ + "img/fabric-slide-1-xxl-me.5ab4be1.webp";